var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-2 input-group"},[_c('a',{staticClass:"roi-help-icon",attrs:{"role":"button","tabindex":"-1"}},[_c('span',{staticClass:"info-text font-main"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }